import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=72626916&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"
import style0 from "./Skills.vue?vue&type=style&index=0&id=72626916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72626916",
  null
  
)

export default component.exports